module.exports = __webpack_public_path__ + "static/img/thumb_13.ef5bb35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_13.png
// module id = qC0v
// module chunks = 0